var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.618 13.954V2.045a.2.2 0 01.326-.155l7.321 5.955a.2.2 0 010 .31l-7.32 5.955a.2.2 0 01-.327-.156z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik00LjYxNzkyIDEzLjk1NDRWMi4wNDU0NkM0LjYxNzkyIDEuODc3MDEgNC44MTM0MyAxLjc4NDAxIDQuOTQ0MTEgMS44OTAzTDEyLjI2NTQgNy44NDQ3NkMxMi4zNjM4IDcuOTI0OCAxMi4zNjM4IDguMDc1MDUgMTIuMjY1NCA4LjE1NTA4TDQuOTQ0MTEgMTQuMTA5NUM0LjgxMzQzIDE0LjIxNTggNC42MTc5MiAxNC4xMjI4IDQuNjE3OTIgMTMuOTU0NFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { Svg16 as ReactComponent };